import { Row, Col, Tag } from 'antd';

const AudiometryAverages = ({ averageData, config, fromExternal }) => {
  const calculateAverage = (frequencies, side, conductionType) => {
    const values = frequencies
      .map((frequency) => {
        const value = averageData?.[frequency]?.[`${conductionType}_${side}`];
        const rawValue = String(value ?? '');
        const num = parseFloat(rawValue.replace('no escucha', '').replace('NR', ''));
        return num;
      })
      .filter((val) => !isNaN(val));
    if (values.length === 0) return '';
    const sum = values.reduce(
      (firstValue, secondValue) => firstValue + secondValue,
      0,
    );
    return (sum / values.length).toFixed(1);
  };

  const cards = config.flatMap((section) =>
    section.ranges.map((range) => ({
      title: section.title,
      conductionType: section.conductionType,
      label: range.label,
      frequencies: range.frequencies,
    })),
  );

  return (
    <div>
      <h2>Promedios</h2>
      <Row gutter={20}>
        {cards.map((card, index) => (
          <Col
            xs={24}
            sm={fromExternal ? 12 : 24}
            lg={fromExternal ? 12 : 6}
            className='avg-col-container'
            key={index}
          >
            <p>{card.title}</p>
            <Row className='pt-15'>
              <Col lg={24} className='avg-header pl-15'>
                <p>{card.label}</p>
              </Col>
              <Col lg={24} className='pt-15 pl-15'>
                {['RE', 'LE'].map((side, sideIndex) => (
                  <Row justify='space-between' key={sideIndex}>
                    <Col lg={12}>
                      <p
                        className={
                          side === 'RE' ? 'right-ear-text' : 'left-ear-text'
                        }
                      >
                        {side === 'RE' ? 'OD' : 'OI'}
                      </p>
                    </Col>
                    <Col lg={12}>
                      <Row justify='end'>
                        <Tag>
                          {calculateAverage(
                            card.frequencies,
                            side,
                            card.conductionType,
                          )}
                        </Tag>
                      </Row>
                    </Col>
                  </Row>
                ))}
              </Col>
            </Row>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default AudiometryAverages;
